export default class GalleryModule {

    static name = 'gallery'

    constructor(node) {
        if(window.pw.debug) return;
        init(node.id)
    }
}

function init(parentId) {

    const mainFolderPath = (window.pw.templates || '/site/templates/') + 'assets/fwd/'
    const playlistId = 'ugp-playlist-' + parentId.split('-').pop()

    //@TODO dismount event or something
    delete window.myUGP

    new FWDUGP({
        //main settings 
        gridType:"dynamicVertical",
        rightClickContextMenu:"default",
        instanceName:"myUGP",
        parentId: parentId,
        mainFolderPath: mainFolderPath,
        gridSkinPath:"grid_skin_classic",
        lightboxSkinPath:"lightbox_skin_classic",
        playlistId: playlistId,
        allCategoriesLabel:"ALL GALLERIES",
        showAllCategories:"yes",
        randomizeCategories:"no",
        animateParent:"yes",
        startAtCategory:0,
        backgroundColor:"transparent",
        //menu settings
        menuType:"list",
        showMenu:"yes",
        multipleCategorySelection:"yes",
        showMenuButtonsSpacers:"no",
        showTotalThumbnailsPerCategory:"yes",
        showSearchBox:"yes",
        centerNoSearchFoundLabelWithMenu:"yes",
        comboboxSelectorLabel:"SELECT GALLERIES",
        menuPosition:"left",
        searchLabel:"search",
        searchNotFoundLabel:"NOTHING FOUND!",
        comboboxArrowNormalColor:"#FFFFFF",
        comboboxArrowSelectedColor:"#000000",
        menuButtonSpacerWidth:1,
        menuButtonSpacerHeight:20,
        menuButtonsSapcerLeftAndRight:10,
        menuMaxWidth:920,
        menuOffsetTop:25,
        menuOffsetBottom:25,
        horizontalSpaceBetweenMenuButtons:10,
        verticalSpaceBetweenMenuButtons:10,
        //thumbnail settings
        thumbnailLoadingType:"loadMoreWithButton",
        hideAndShowTransitionType:"scale",
        thumbanilBoxShadow:"",
        disableThumbnails:"no",
        inverseButtonsIcons:"no",
        thumbnailBackgroundColor:"#333333",
        thumbnailBorderNormalColor:"#FFFFFF",
        thumbnailBorderSelectedColor:"#c1c1c1",
        howManyThumbnailsToDisplayPerSet:999,
        thumbnailsHorizontalOffset:0,
        thumbnailsVerticalOffset:0,
        thumbnailMaxWidth:278,
        thumbnailMaxHeight:188,
        horizontalSpaceBetweenThumbnails:0,
        verticalSpaceBetweenThumbnails:0,
        thumbnailBorderSize:0,
        thumbnailBorderRadius:0,
        //load more button settings
        loadMoreButtonLabel:"LOAD MORE THUMBNAILS",
        loadMoreButtonOffsetTop:25,
        loadMoreButtonOffsetBottom:25,
        //preset settings
        preset:"scaletext",
        textVerticalAlign:"center",
        useIconButtons:"no",
        thumbnailOverlayColor:"#000000",
        thumbnailOverlayOpacity:.8,
        thumbnailIconWidth:30,
        thumbnailIconHeight:29,
        spaceBetweenThumbanilIcons:12,
        spaceBetweenTextAndIcons:4,
        //ligtbox settings (optional)
        //facebookAppId:"213684265480896",
        buttonsAlignment:"in",
        itemBoxShadow:"none",
        descriptionWindowAnimationType:"opacity",
        descriptionWindowPosition:"bottom",
        useAsModal:"no",
        slideShowAutoPlay:"no",
        addKeyboardSupport:"yes",
        showCloseButton:"yes",
        showShareButton:"no",
        showZoomButton:"no",
        showSlideShowButton:"yes",
        showSlideShowAnimation:"yes",
        showNextAndPrevButtons:"yes",
        showNextAndPrevButtonsOnMobile:"yes",
        showDescriptionButton:"no",
        showDescriptionByDefault:"yes",
        videoShowFullScreenButton:"yes",
        videoAutoPlay:"no",
        nextVideoOrAudioAutoPlay:"no",
        videoLoop:"no",
        audioAutoPlay:"no",
        audioLoop:"no",
        backgroundOpacity:.9,
        descriptionWindowBackgroundOpacity:.95,
        buttonsHideDelay:3,
        slideShowDelay:4,
        defaultItemWidth:640,
        defaultItemHeight:480,
        itemOffsetHeight:50,
        spaceBetweenButtons:1,
        buttonsOffsetIn:2,
        buttonsOffsetOut:5,
        itemBorderSize:0,
        itemBorderRadius:0,
        itemBackgroundColor:"#333333",
        itemBorderColor:"#333333",
        lightBoxBackgroundColor:"#000000",
        descriptionWindowBackgroundColor:"rgba(0,0,0,0.4)",
        videoPosterBackgroundColor:"#0099FF",
        videoControllerBackgroundColor:"#FFFFFF",
        audioControllerBackgroundColor:"#FFFFFF",
        timeColor:"#000000"
    });
}